export default __webpack_public_path__ + "static/media/project2.b9492b9f.png";